// Typelizer digest 6aec7de52f0277b331d40d2800b919ea
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** POST /c/:company_id/purchase_orders/:purchase_order_id/duplicate */
  create: (
    params: { purchaseOrderId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/c/:company_id/purchase_orders/:purchase_order_id/duplicate', params, options),
    method: 'post',
  }),
}
